export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sku/timeTable/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/sku/timeTable/get?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/sku/timeTable/save`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/sku/timeTable/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/sku/timeTable/delete`,
                data
            })
        },

        updateState(data) {
            return http.json({
                url: `/sku/timeTable/updateState`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/timeTable.js